import {inject, Injectable} from '@angular/core';
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {testingResultFilesResourceType} from "../configs/testing-result-files-config";
import {AttachProductCardFileParams, DeleteFileParams} from "../../../../types/product-card-files.types";
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";

@Injectable({
  providedIn: 'root'
})
export class TestingResultFilesService {
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);

  public setDataInModalParams(parentId: number): GetDataInModalParams {
    return {
      path: testingResultFilesResourceType.path,
      queryParams: { testingResultId: parentId }
    };
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
